import __request__ from "routing/request";
export function get() {
  return __request__("GET", "/system/outputs", null, {}, {
    "Accept": ["application/json"]
  });
}
export function create(JSONbody) {
  return __request__("POST", "/system/outputs", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function available() {
  return __request__("GET", "/system/outputs/available", null, {}, {
    "Accept": ["application/json"]
  });
}
export function getByoutputId(outputId) {
  return __request__("GET", `/system/outputs/${outputId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function update(outputId, JSONbody) {
  return __request__("PUT", `/system/outputs/${outputId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function remove(outputId) {
  return __request__("DELETE", `/system/outputs/${outputId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
